export const SERVER_URL='https://dt.aosmith.in'
// export const SERVER_URL='http://localhost:5000' 
export const ASSETS_URL=SERVER_URL
export const POCKET_BASE_URL='https://pockethrms.blob.core.windows.net/profileimages-aosmi1886daa12d/AOSmi1886daa12d-'

export const API_URL={
    banners:'/admin/banners',
    users:'/admin/users',
    policies:'/admin/policies',
    events:'/admin/events',
    downloads:'/admin/downloads',
    status:'/admin/status',
    today:'/admin/users/today-celebrations',
    birthMonth:'/admin/users/birthdays-this-month',
    aniversaryMonth:'/admin/users/anniversaries-this-month',
    blogs:'/admin/blogs',
    blogsPublished:'/admin/blogs/published',
    videos:'/admin/videos',
    imageContent:'/admin/image-content'
}